// @flow
import { toggleDialog } from '../base/dialog/actions';
import { DEFAULT_LANGUAGE } from '../base/i18n/i18next';

import {
    REMOVE_CACHED_TRANSCRIPT_MESSAGE,
    REMOVE_TRANSCRIPT_MESSAGE,
    SET_DEFAULT_TRANSCRIPTION_LANGUAGE,
    SET_REQUESTING_SUBTITLES,
    TOGGLE_REQUESTING_CAPTIONS,
    TOGGLE_REQUESTING_SUBTITLES,
    UPDATE_TRANSCRIPT_MESSAGE
} from './actionTypes';
import LanguageSelectorDialog from './components/web/LanguageSelectorDialog.web';

/**
 * Signals that a cached transcript has to be removed from the state.
 *
 * @param {string} transcriptMessageID - The message_id to be removed.
 * @returns {{
*      type: REMOVE_CACHED_TRANSCRIPT_MESSAGE,
*      transcriptMessageID: string,
* }}
*/
export function removeCachedTranscriptMessage(transcriptMessageID: string) {
    return {
        type: REMOVE_CACHED_TRANSCRIPT_MESSAGE,
        transcriptMessageID
    };
}

// /**
//  * Signals that a participant sent an endpoint message on the data channel.
//  *
//  * @param {Object} participant - The participant details sending the message.
//  * @param {Object} json - The json carried by the endpoint message.
//  * @returns {{
//  *      type: ENDPOINT_MESSAGE_RECEIVED,
//  *      participant: Object,
//  *      json: Object
//  * }}
//  */
// export function endpointMessageReceived(participant: Object, json: Object) {
//     return {
//         type: ENDPOINT_MESSAGE_RECEIVED,
//         participant,
//         json
//     };
// }

/**
 * Signals that the local user has toggled the ClosedCaption button.
 *
 * @returns {{
 *      type: TOGGLE_REQUESTING_SUBTITLES
 * }}
 */
export function toggleRequestingSubtitles() {
    return {
        type: TOGGLE_REQUESTING_SUBTITLES
    };
}

/**
 * Open and close Captions Modal ClosedCaption button.
 *
 * @returns {{
 *      type: TOGGLE_REQUESTING_CAPTIONS
 * }}
 */
export function closeCaptionsModal(requestingCaptionsModal: Boolean) {
    return {
        type: TOGGLE_REQUESTING_CAPTIONS,
        requestingCaptionsModal
    };
}

/**
 * Signals that the local user has toggled the LanguageSelector button.
 *
 * @returns {Function}
 */
export function toggleLanguageSelectorDialog() {
    return function(dispatch) {
        dispatch(toggleDialog(LanguageSelectorDialog));
    };
}

/**
 * Signals that the local user has enabled or disabled the subtitles.
 *
 * @param {boolean} enabled - The new state of the subtitles.
 * @param {boolean} displaySubtitles - Whether to display subtitles or not.
 * @param {string} language - The language of the subtitles.
 * @returns {{
 *    type: SET_REQUESTING_SUBTITLES,
 *    enabled: boolean,
 *    displaySubtitles: boolean,
 *    language: string
 * }}
 */
export function setRequestingSubtitles(
        enabled: boolean,
        displaySubtitles = true,
        language: string | null = `translation-languages:${DEFAULT_LANGUAGE}`
) {
    return {
        type: SET_REQUESTING_SUBTITLES,
        displaySubtitles,
        enabled,
        language
    };
}

/**
 * Signals that a transcript has to be removed from the state.
 *
 * @param {string} transcriptMessageID - The message_id to be removed.
 * @returns {{
 *      type: REMOVE_TRANSCRIPT_MESSAGE,
 *      transcriptMessageID: string,
 * }}
 */
export function removeTranscriptMessage(transcriptMessageID: string) {
    return {
        type: REMOVE_TRANSCRIPT_MESSAGE,
        transcriptMessageID
    };
}

/**
 * Signals that a transcript with the given message_id to be added or updated
 * is received.
 *
 * @param {string} transcriptMessageID -The transcript message_id to be updated.
 * @param {Object} newTranscriptMessage - The updated transcript message.
 * @returns {{
 *      type: UPDATE_TRANSCRIPT_MESSAGE,
 *      transcriptMessageID: string,
 *      newTranscriptMessage: Object
 * }}
 */
export function updateTranscriptMessage(
        transcriptMessageID: string,
        newTranscriptMessage: Object
) {
    return {
        type: UPDATE_TRANSCRIPT_MESSAGE,
        transcriptMessageID,
        newTranscriptMessage
    };
}

/**
 * setting default transcription lang to en-US.
 *
 * @param {boolean} _showDefaultTranscriptionLang
 * @returns {{
*      type: SET_DEFAULT_TRANSCRIPTION_LANGUAGE,
*      _showDefaultTranscriptionLang: boolean,
* }}
*/
export function setDefaultTranscriptionLang(_showDefaultTranscriptionLang: boolean) {

    return {
        type: SET_DEFAULT_TRANSCRIPTION_LANGUAGE,
        _showDefaultTranscriptionLang
    };
}
